export default __webpack_public_path__ + "0f3e0780b632e813f8638ea1edd65d6a.svg";